import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type MediaToolCategory = components["schemas"]["V2MediaToolOperation"]["category"];
export type MediaToolCatalog = components["schemas"]["V2MediaToolCatalog"];
export type MediaToolOperation = components["schemas"]["V2MediaToolOperation"];
export type MediaToolVariant = components["schemas"]["V2ProductVariant"];
export type MediaToolSetting = components["schemas"]["V2SettingCapability"];
export type MediaToolReference = components["schemas"]["V2ReferenceInputCapability"];

/** Exact tool surfaces; execution and customer quotes have separate authorities. */
export async function getMediaToolCatalog(
  category: MediaToolCategory,
  signal?: AbortSignal,
): Promise<MediaToolCatalog> {
  return unwrap(await api.GET("/v1/media-tools", {
    params: { query: { category } },
    signal,
  }));
}
